import React from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import { useTranslation } from '../../../../translations';

const ShopInfoGift = React.forwardRef(function ShopInfoGift({ info }, ref) {
  const { t } = useTranslation();

  return (
    <div className={'shop__info-gift'}>
      <img src={info.img} alt={'cashback-img'} />
      <div className={'shop__info-gift-cashback'}>{t(info.cashback)}</div>
    </div>
  );
});

export default ShopInfoGift;
ShopInfoGift.propTypes = {};
